import React from 'react'
import Footer from '../../components/Footer'
import PharmacyImg from "../../assets/images/diplomao.jpeg";
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Title from '../../components/TitleComponent';

const DiplomaFoodandBeverage = () => {
  return (
    <div className='w-full relative font-poppins bg-gray-50'>
      <Title canonicalPath="/programmes/diploma-courses/diploma-in-food-and-beverage" />
      <Title title="Diploma in Food and Beverage at Maya Devi University" description="Join the Diploma in Food and Beverage program at Maya Devi University, Dehradun. Master the skills needed for a successful career in the food and hospitality industry." />
      <div className='w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5'>
        {/* Hero Section with Modern Styling */}
        <div className='text-center mb-10'>
          <h2 className='mb-4 text-2xl md:text-6xl tracking-tight font-bold text-[#0e4d38] 
            bg-gradient-to-r from-[#0e4d38] to-[#23376c] text-transparent bg-clip-text'>
            Diploma in F&B Service and Bar Tending
          </h2>
          <div className='w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px] rounded-full'></div>
        </div>

        {/* Main Content with Card-like Design */}
        <div className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between 
          bg-white shadow-lg rounded-xl p-6 md:p-10'>
          <img
            src={PharmacyImg}
            className='md:w-[40%] rounded-lg object-cover shadow-md transition-transform duration-300 hover:scale-105'
            alt="Diploma Program"
          />
          <div className='flex flex-col gap-4'>
            <h4 className='font-bold text-xl md:text-3xl text-[#0e4d38]'>About the Department</h4>
            <p className='text-justify md:text-lg text-gray-700 leading-relaxed'>
              {/* Existing paragraph content */}
              The Diploma in F&B Service and Bartending and an extensive 1 ½ year program aimed at equipping students for fulfilling careers in the hospitality sector. The Diploma in F&B Service  and Bartending offers a comprehensive education in the art and science of F&B Service and Bartending. With a blend of theoretical knowledge and practical training, graduates are prepared to excel in a variety of roles within the hospitality industry. Whether aspiring to become a skilled bartender, a knowledgeable sommelier, or a proficient F&B manager, this diploma program provides the foundation for a successful career in the dynamic world of hospitality.
            </p>
            <Link to="https://admission.maya.edu.in/" className='self-start'>
              <button
                className='mt-5 md:mt-0 bg-[#23376c] px-6 py-3 text-white rounded-full font-semibold 
                transition-all duration-200 hover:bg-[#4865b3] flex items-center gap-2 group'
              >
                Register Now
                <ArrowRight className='group-hover:translate-x-1 transition-transform' size={20} />
              </button>
            </Link>
          </div>
        </div>

        {/* Tables with Modern Styling */}
        <div className="space-y-8">
          {/* First Table */}
          <div className="bg-white shadow-md rounded-xl overflow-x-auto ">
            <table className="min-w-full text-center text-sm font-light">
              <thead className="bg-[#23376c] text-white">
                <tr>
                  <th className="px-6 py-4">Programme</th>
                  <th className="px-6 py-4">Branch/ Specialization</th>
                  <th className="px-6 py-4">Duration (Years)</th>
                  <th className="px-6 py-4">No. of Seats</th>
                  <th className="px-6 py-4">One time Charges</th>
                  {/* <th className="px-6 py-4">Yearly Fee (All India Quota)</th>
                  <th className="px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="whitespace-nowrap px-6 py-4 font-semibold">Diploma in Hotel Management (DHM)</td>
                  <td className="whitespace-nowrap px-6 py-4">Bar Tender and F & B Service</td>
                  <td className="whitespace-nowrap px-6 py-4">1+1</td>
                  <td className="whitespace-nowrap px-6 py-4">20</td>
                  {/* <td className="whitespace-nowrap px-6 py-4">Rs.11000/-</td>
                  <td className="whitespace-nowrap px-6 py-4">Rs.60000/-</td>
                  <td className="whitespace-nowrap px-6 py-4">Rs.45000/-</td> */}
                </tr>
              </tbody>
            </table>
          </div>

          {/* Hostel Fee Table */}
          {/* <div className="bg-white shadow-md rounded-xl overflow-x-auto ">
            <table className="min-w-full text-center text-sm font-light">
              <thead className="bg-[#23376c] text-white">
                <tr>
                  <th colSpan="3" className="px-6 py-4">Hostel Fee</th>
                </tr>
                <tr>
                  <th className="px-6 py-4">Sr. No</th>
                  <th className="px-6 py-4">Type</th>
                  <th className="px-6 py-4">Fee</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { no: 1, type: 'Triple Sharing (Non AC)', fee: '75000/-' },
                  { no: 2, type: 'Double Sharing (Non Ac)', fee: '85000/-' },
                  { no: 3, type: 'Triple Sharing (AC)', fee: '115000/-' },
                  { no: 4, type: 'Double Sharing (Ac)', fee: '125000/-' }
                ].map((item) => (
                  <tr key={item.no} className="border-b">
                    <td className="whitespace-nowrap px-6 py-4">{item.no}</td>
                    <td className="whitespace-nowrap px-6 py-4">{item.type}</td>
                    <td className="whitespace-nowrap px-6 py-4">{item.fee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div> */}
        </div>

        {/* Additional Sections with Modern Card Design */}
        <div className='space-y-8 mt-10 mb-[100px]'>
          {[
            {
              title: 'Eligibility Criteria',
              content: '10+2 (In any Stream)'
            },
            {
              title: 'Career Prospects of the Course',
              content: [
                'Hospitality & Tourism industry is the largest industry in the world contributing 10% of the world GDP.',
                'With hotels like Marriott, Hilton, Hyatt, Wyndham Hotels & Resorts, Taj, Oberai, the growth potential for Hospitality sector is big.',
                'Management Trainee in Hotel and applied hospitality industry',
                'Guest/Customer Relation Executive in Hotel and other Service Sectors',
                'Management Trainee/Executive in international and national fast food chains',
                'Hospital and Institutional Catering',
                'Railway Hospitality and Catering Services',
                'State Tourism Development Corporations',
                'Shipping and Cruise lines',
                'Resort Management',
                'Self-employment through entrepreneurship and Multinational companies for their hospitality services'
              ]
            },
            {
              title: 'Career Options',
              content: [
                'Hotel Manager',
                'Restaurant Manager',
                'Bartender',
                'Flight attendant',
                'Event Manager',
                'Marketing Executive',
                'Sales Executive',
                'KST Manager',
                'F&B Controller'
              ]
            }
          ].map((section, index) => (
            <div
              key={index}
              className='bg-white shadow-md rounded-xl p-6 hover:shadow-lg transition-shadow'
            >
              <h4 className='text-2xl font-semibold text-[#0e4d38] mb-4'>{section.title}</h4>
              {Array.isArray(section.content) ? (
                <ul className='list-disc pl-5 space-y-2'>
                  {section.content.map((item, i) => (
                    <li key={i} className='text-gray-700'>{item}</li>
                  ))}
                </ul>
              ) : (
                <p className='text-gray-700'>{section.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default DiplomaFoodandBeverage